import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Forum from './Forum';
import UpdateSuccess from './UpdateSuccess';

function NewPaymentMethod({ classes, setNewPaymentMethod }) {
  const dispatch = useDispatch();
  const [forum, setForum] = useState(true);


  if(forum == true){
      return (
          <Forum classes={classes} setNewPaymentMethod = {setNewPaymentMethod} setForum = {setForum} />
      )
  }
  else
  {
      return (
          <UpdateSuccess classes={classes} setNewPaymentMethod = {setNewPaymentMethod} />
      )
  }
}

export default NewPaymentMethod;
